import React, { useState } from 'react';
import styled from 'styled-components';
import { TabMediaText } from './TabMediaText';
import { VideoThumbnail, VideoLightbox } from '../../Video';
import { TabMediaContainer, Divider } from './TabImageContent';
import media from '../../../utils/media';
const ThumbnailContainer = styled.div `
  width: 540px;
  height: 340px;

  ${media.mobile} {
    height: 170px;
    width: 100%;
    margin-bottom: 30px;
  }
`;
export const TabVideoContent = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const { contentAlignment, contentSubtitle, contentTitle, contentBodyText, ctaLink, ctaLinkText, ctaType, thumbnailImage, logoImage, video, } = fields;
    return (React.createElement(TabMediaContainer, { alignment: contentAlignment.value },
        React.createElement(VideoLightbox, { isOpen: isVideoOpen, onClose: () => setIsVideoOpen(false), 
            // TODO: Finalize aria-label approach app-wide
            closeIconLabel: 'Close Lightbox', videoLabel: 'Video', video: video, videoHeight: 70, isContained: false }),
        React.createElement(ThumbnailContainer, null,
            React.createElement(VideoThumbnail, { media: thumbnailImage, onPlay: () => setIsVideoOpen(true) })),
        React.createElement(Divider, null),
        React.createElement(TabMediaText, { fields: {
                contentSubtitle,
                contentTitle,
                contentBodyText,
                ctaLink,
                ctaLinkText,
                ctaType,
                logoImage,
            } })));
};
